import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';

export const ParkingAccessSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const text = report.testFitAnalysis?.parkingAccess;
  return (
    <SectionShell label={label} hasData={!!text} report={report}>
      {text && <p>{text}</p>}
    </SectionShell>
  );
};
